<template>
  <div
    v-cloak
    :style="{
      paddingBottom: `${
        !($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) ? 60 : 90
      }px`
    }"
  >
    <template v-if="info">
      <v-overlay :opacity="0.6" v-model="failDialog.show" z-index="6">
        <v-dialog v-model="failDialog.show" maxWidth="400" persistent>
          <v-card rounded="sm" class="pb-9">
            <v-sheet class="grey-1" height="8" />
            <v-img
              :src="require(`@/assets/image/ic-warning@3x.png`)"
              class="ma-auto mt-7 mb-5"
              alt=""
              width="120"
              height="120"
            />
            <div class="text-26 font-weight-bold text-center">
              {{ failDialog.message }}
            </div>
          </v-card>
        </v-dialog>
      </v-overlay>
      <v-overlay :opacity="0.6" v-model="ATMAccountDialog" z-index="6">
        <v-dialog
          v-model="ATMAccountDialog"
          maxWidth="672"
          class="atm-account-dialog"
        >
          <div class="text-center" style="position: relative; ">
            <v-card rounded="sm">
              <v-img
                :src="
                  'data:image/jpeg;base64, ' + info.onlineRefundATMAccountPic
                "
                contain
                alt=""
                width="100%"
                height="500"
              />
            </v-card>
            <v-btn
              icon
              class="mt-6 atm-close-btn"
              @click="ATMAccountDialog = false"
              ><v-icon color="primary">mdi-close</v-icon></v-btn
            >
          </div>
        </v-dialog>
      </v-overlay>
      <v-overlay :opacity="0.6" v-model="rejectDialog.show" z-index="6">
        <v-dialog
          class="ma-0"
          v-model="rejectDialog.show"
          :width="475"
          :height="$vuetify.breakpoint.xs ? 400 : 533"
          :persistent="false"
          hide-overlay
        >
          <v-card class="py-5 px-8">
            <h2 class="mb-4 text-center">{{ $t("refund_reject") }}</h2>
            <div class="text-small" v-html="rejectDialog.content"></div>

            <v-spacer />
            <div class="text-center mt-10">
              <v-btn
                @click="rejectDialog.show = false"
                outlined
                depressed
                rounded
                class="primary-1"
                color="white"
              >
                {{ $t("order_step_1_reserve_dialog_cta") }}
              </v-btn>
            </div>
          </v-card>
        </v-dialog>
      </v-overlay>
      <v-overlay :opacity="0.6" v-model="dialog.show" z-index="6">
        <v-dialog
          class="ma-0"
          v-model="dialog.show"
          :width="475"
          :height="$vuetify.breakpoint.xs ? 400 : 533"
          :persistent="false"
          hide-overlay
        >
          <v-card class="py-5 px-8">
            <h2 class="mb-4 text-center">
              {{
                $t(
                  !!info.signupLottery ? "cancellation_failed" : "refund_failed"
                )
              }}
            </h2>
            <div
              class="text-small"
              v-html="
                $t(
                  !!info.signupLottery
                    ? 'cancellation_failed_content'
                    : 'refund_failed_content'
                )
              "
            ></div>
            <v-spacer />
            <div class="text-center mt-10">
              <v-btn
                @click="dialog.show = false"
                outlined
                depressed
                rounded
                class="primary-1"
                color="white"
              >
                {{ $t("order_step_1_reserve_dialog_cta") }}
              </v-btn>
            </div>
          </v-card>
        </v-dialog>
      </v-overlay>
      <v-overlay :opacity="0.6" v-model="confirmDialog.show" z-index="6">
        <v-dialog
          class="ma-0"
          v-model="confirmDialog.show"
          :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 475 : 1000"
          :height="$vuetify.breakpoint.xs ? 400 : 533"
          :persistent="false"
          hide-overlay
        >
          <v-card class="py-5 px-8">
            <h2 class="mb-4">
              {{
                $t(
                  !!info.signupLottery
                    ? "cancellation_comfirm"
                    : "refund_confirm"
                )
              }}
            </h2>
            <div
              class="blue-text"
              v-html="
                $t(
                  !!info.signupLottery
                    ? 'cancellation_confirm_content'
                    : info.total === 0
                    ? `refund_confirm_content_no_tip`
                    : '',
                  {
                    refundNumber: selectedTickets.length,
                    AmtOnlineRefundType: refundType
                  }
                )
              "
            ></div>
            <div class="refund-title mt-5">
              <v-row class="bg-transparent-yellow">
                <v-col class="py-2">{{
                  $t(
                    !!info.signupLottery
                      ? "cancellation_overview"
                      : "refund_list"
                  )
                }}</v-col>
              </v-row>
              <v-row
                v-for="(t, index) in selectedTickets"
                :key="`refund${t.ticketNum}`"
                class="refund-row"
              >
                <v-col :cols="6" :sm="6" :md="3"
                  ><div class="primary-1--text text-mini">
                    {{ $t("orderlist_serial_no") }}
                  </div>
                  {{ t.entrySN || "-" }}
                </v-col>
                <v-col :cols="6" :sm="6" :md="3"
                  ><div class="primary-1--text text-mini">
                    {{ $t("orderlist_product_name") }}
                  </div>
                  {{ t.productName }}
                </v-col>
                <v-col :cols="6" :sm="6" :md="2" v-if="t.seatInfo.area"
                  ><div class="primary-1--text text-mini">
                    {{ $t("orderlist_ticketarea_name") }}
                  </div>
                  {{ t.seatInfo.area || "-" }}
                </v-col>
                <v-col :cols="6" :sm="6" :md="2" v-if="t.seatInfo.seat"
                  ><div class="primary-1--text text-mini">
                    {{ $t("orderlist_ticketarea_seat") }}
                  </div>
                  {{ t.seatInfo.seat || "-" }}
                </v-col>
                <v-col v-if="t.applicant" :cols="6" :sm="6" :md="2"
                  ><div class="primary-1--text text-mini">
                    {{ $t("userinfo_name") }}
                  </div>
                  {{ t.applicant.identityName }}
                </v-col>
              </v-row>
            </div>
            <div class="text-center red--text text-small mt-5">
              {{
                $t(
                  !!info.signupLottery
                    ? "cancellation_comfirmation"
                    : "refund_comfirmation"
                )
              }}
            </div>
            <v-spacer />
            <v-row class="text-center pt-6 d-flex" justify="end">
              <v-col :cols="12">
                <v-divider class="mb-5" />
              </v-col>
              <v-col :xs="12" :md="3">
                <v-btn
                  @click="confirmDialog.show = false"
                  outlined
                  depressed
                  block
                  class="primary-1 flex-grow"
                  color="white"
                >
                  {{ $t("layout_notification_cancel") }}
                </v-btn>
              </v-col>
              <v-col :xs="12" :md="3">
                <v-btn
                  @click="doRefund"
                  depressed
                  block
                  class="nextBtn flex-grow"
                  color="white"
                >
                  {{ $t("dialog_default_confirm") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-overlay>

      <CustomPageHeaderVue class="flex-grow-0">{{
        $t(!!info.signupLottery ? "order_cancel_lottery" : "refund")
      }}</CustomPageHeaderVue>
      <template v-if="status === 'init'">
        <CustomRow>
          <ProgressCircular v-if="isLoading" />
          <v-card
            v-else
            class="mt-5 customCard bg-transparent"
            min-height="auto"
            :elevation="
              !($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) ? 8 : 0
            "
            :class="{
              'cusPadding white': !(
                $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
              )
            }"
          >
            <v-container fluid v-if="info">
              <v-row class="order-header">
                <v-col class="py-2">
                  <span class="mr-3">{{ $t("orderlist_order_no") }}</span>
                  <b>#{{ $route.params.orderNum }}</b>
                </v-col>
              </v-row>
              <v-row class="order-info">
                <v-col class="py-2">
                  <h3>{{ info.sessionName || "" }}</h3>
                  <div>
                    {{ info.sessionLocation || "" }}<br />{{
                      info.sessionDateTime || ""
                    }}
                  </div>
                </v-col>
              </v-row>
              <v-row
                class="bg-transparent-blue py-3 py-md-4"
                :class="
                  $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                    ? 'text-small py-0'
                    : 'text-regular py-4'
                "
              >
                <v-col class="py-0">
                  <span class="mr-3 is-text-regular">{{
                    $t("refund_method")
                  }}</span>
                  <b class="font-weight-bold">{{ refundType }}</b>
                  <template v-if="info.transType === 'ATM' && info.total > 0">
                    <template
                      v-if="
                        info.onlineRefundATMAccountPic &&
                          info.onlineRefundATMAccountPic !== ''
                      "
                      ><v-btn
                        text
                        @click="
                          () => {
                            ATMAccountDialog = true;
                          }
                        "
                        class=" ml-2"
                        >{{ $t("refund_type_review") }}</v-btn
                      ></template
                    >
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-bind="attrs"
                          v-on="on"
                          class="grey--text ml-2"
                          >{{ $t("refund_type_review") }}</v-btn
                        >
                      </template>
                      <span>{{ $t("refund_type_bank_tooltip") }}</span>
                    </v-tooltip></template
                  >
                </v-col>
              </v-row>
              <v-row
                class="bg-transparent-yellow"
                :class="
                  $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                    ? 'text-small py-0'
                    : 'text-regular py-4'
                "
              >
                <v-col>{{
                  $t(
                    !!info.signupLottery
                      ? "cancellation_overview"
                      : "refund_list"
                  )
                }}</v-col>
              </v-row>
              <v-row class="refund-list">
                <v-col
                  cols="12"
                  v-for="(t, index) in tickets"
                  :key="`refund${t.ticketNum}`"
                  class="refund"
                  @click="refundTicket(t)"
                  :class="{
                    'is-completed': t.onLineRefundStatusName === '已完成退票',
                    'is-rejected': t.onLineRefundStatusName === '拒絕退票',
                    'is-entry': t.onLineRefundStatusName === '已入場',
                    'is-proccessing': t.onLineRefundStatusName === '待審核',
                    'is-proccessing': t.onLineRefundStatusName === '處理中'
                  }"
                >
                  <v-checkbox
                    v-model="refund"
                    :value="t.ticketNum"
                    hide-details
                    class="ma-0"
                    :disabled="
                      !t.allowOnlineRefund || t.onLineRefundStatusName !== ''
                    "
                  >
                    <template v-slot:label>
                      <div class="d-flex flex-wrap my-md-2">
                        <div class="refund-item">
                          <div class="label">
                            {{ $t("orderlist_ticket_no") }}({{
                              $t("ent_tax_num")
                            }})
                          </div>
                          <div>
                            {{ t.ticketNum }}<br />({{ t.entTaxNum || "-" }})
                          </div>
                        </div>
                        <div class="refund-item">
                          <div class="label">
                            {{ $t("orderlist_serial_no") }}
                          </div>
                          <div>{{ t.entrySN || "-" }}</div>
                        </div>
                        <div class="refund-item" v-if="t.seatInfo.area">
                          <div class="label">
                            {{ $t("orderlist_ticketarea_name") }}
                          </div>
                          <div>{{ t.seatInfo.area || "-" }}</div>
                        </div>
                        <div class="refund-item" v-if="t.seatInfo.seat">
                          <div class="label">
                            {{ $t("orderlist_ticketarea_seat") }}
                          </div>
                          <div>{{ t.seatInfo.seat || "-" }}</div>
                        </div>
                        <div class="refund-item">
                          <div class="label">
                            {{ $t("orderlist_product_name") }}
                          </div>
                          <div>{{ t.productName }}</div>
                        </div>
                        <div class="refund-item">
                          <div class="label">
                            {{ $t("orderlist_product_sum") }}
                          </div>
                          <div>NT. {{ t.singleTicketPrice }}</div>
                        </div>
                        <div class="refund-item" v-if="t.applicant">
                          <div class="label">
                            {{ $t("userinfo_name") }}
                          </div>
                          <div>{{ t.applicant.identityName }}</div>
                        </div>
                      </div>
                    </template>
                  </v-checkbox>
                  <template v-if="t.onLineRefundStatusName !== ''">
                    <div
                      v-if="t.onLineRefundStatusName === '待審核'"
                      class="ribbon"
                    >
                      待審核
                    </div>
                    <div
                      v-if="t.onLineRefundStatusName === '處理中'"
                      class="ribbon"
                    >
                      {{ $t("refund_processing") }}
                    </div>
                    <div
                      v-if="t.onLineRefundStatusName === '已完成退票'"
                      class="ribbon"
                    >
                      {{
                        $t(
                          !!info.signupLottery
                            ? "cancellation_success"
                            : "refund_success"
                        )
                      }}
                    </div>
                    <div
                      v-if="t.onLineRefundStatusName === '拒絕退票'"
                      class="ribbon text-center"
                    >
                      {{ $t("refund_rejected") }}<br />
                      <v-icon color="red darken-2"
                        >mdi-information-outline</v-icon
                      >
                    </div>
                    <div
                      v-if="t.onLineRefundStatusName === '已入場'"
                      class="ribbon"
                    >
                      {{ $t("order_admitted") }}
                    </div>
                  </template>
                </v-col>
              </v-row>
              <v-row class="refund-info">
                <v-col>
                  <h5 class="blue-text">
                    {{
                      $t(
                        !!info.signupLottery
                          ? "registration_notes"
                          : "refund_notification"
                      )
                    }}
                  </h5>
                  <div
                    v-html="
                      $t(
                        !!info.signupLottery
                          ? 'calcellation_notification_content'
                          : 'refund_notification_content'
                      )
                    "
                  ></div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </CustomRow>
        <div class="order-footer">
          <CustomRow>
            <v-row no-gutters class="py-3">
              <v-col cols="12" class="text-right pl-2">
                <v-btn
                  class="mr-3"
                  @click="$router.push({ name: 'OrderList' })"
                  depressed
                  outlined
                  :x-large="!$vuetify.breakpoint.xs"
                  >{{ $t("back") }}</v-btn
                >
                <v-btn
                  class="nextBtn"
                  :class="{ disabledBtn: !canNextStep }"
                  :disabled="!canNextStep"
                  @click="nextStep"
                  depressed
                  :x-large="!$vuetify.breakpoint.xs"
                  >{{ $t("next_step") }}</v-btn
                >
              </v-col>
            </v-row>
          </CustomRow>
        </div>
      </template>
      <template v-if="status === 'refund'">
        <CustomRow>
          <v-card
            class="mt-5 customCard bg-transparent"
            :min-height="contentHeight"
            :elevation="
              !($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) ? 8 : 0
            "
            :class="{
              'cusPadding white': !(
                $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
              )
            }"
          >
            <v-container fluid>
              <v-row justify="center">
                <v-col :xs="12" :md="7">
                  <h3 class="blue-text mt-4">
                    {{ $t("refund_upload_title") }}
                  </h3>
                  <file-upload
                    :deleteBtn="true"
                    name="accountInfo"
                    :default="accountInfo.path"
                    :result="accountInfo.result || null"
                    @change="uploadPhoto"
                  />
                  <div>
                    <h5 class="blue-text">
                      {{ $t("refund_upload_note_title") }}
                    </h5>
                    <div v-html="$t('refund_upload_note_content')"></div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </CustomRow>
        <div class="order-footer">
          <CustomRow>
            <v-row no-gutters class="py-3">
              <v-col cols="12" class="text-right pl-2">
                <v-btn
                  class="mr-3"
                  @click="
                    () => {
                      this.status = 'init';
                    }
                  "
                  depressed
                  outlined
                  :x-large="!$vuetify.breakpoint.xs"
                  >{{ $t("layout_notification_cancel") }}</v-btn
                >
                <v-btn
                  class="nextBtn"
                  :class="{ disabledBtn: !canSubmit }"
                  :disabled="!canSubmit"
                  @click="doSubmit"
                  depressed
                  :x-large="!$vuetify.breakpoint.xs"
                  >{{ $t("next_step") }}</v-btn
                >
              </v-col>
            </v-row>
          </CustomRow>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import OM from "@/api/order-management";
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";
import FileUpload from "../components/FileUpload.vue";

export default {
  name: "OrderRefund",
  components: {
    CustomPageHeaderVue,
    FileUpload
  },
  computed: {
    canNextStep() {
      return this.refund.length > 0;
    },
    canSubmit() {
      return !!this.accountInfo.path;
    },
    refundType() {
      if (!this.info) return "";
      let str = "";
      switch (this.info.transType) {
        case "ATM":
          str =
            this.info.total > 0
              ? this.$t("refund_bank_acct")
              : this.$t("refund_noneed");
          break;
        case "CC":
          str = this.$t("refund_credit_card");
          break;
        case "FREE":
          str = this.$t("refund_noneed");
      }
      return str;
    }
  },
  data() {
    return {
      isLoading: false,
      tooltipShow: false,
      status: "init",
      order: null,
      failDialog: {
        show: false,
        message: ""
      },
      accountInfo: {
        path: null
      },
      contentHeight:
        this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
          ? "auto"
          : "calc(100vh - 2200px)",
      info: null,
      tickets: [],
      selectedTickets: [],
      refund: [],
      ATMAccountDialog: false,
      rejectDialog: {
        content: "",
        show: false
      },
      confirmDialog: {
        show: false
      },
      dialog: {
        show: false
      }
    };
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show"
    }),
    async doRefund() {
      this.confirmDialog.show = false;

      if (
        this.info.transType === "ATM" &&
        this.info.total > 0 &&
        (!this.info.onlineRefundATMAccountPic ||
          this.info.onlineRefundATMAccountPic === "")
      ) {
        const params = new FormData();
        params.append("orderNum", this.$route.params.orderNum);
        params.append("onlineRefundATMAccount", this.accountInfo.path);

        const { data: uploadData } = await OM.uploadOnlineRefundATMAccount(
          params
        );

        if (uploadData.errCode !== "00") {
          this.showDialog({
            alert: true,
            title: this.$t("activity_busy_title"),
            content: this.$t("activity_busy_content")
          });
          return;
        }
      }

      const { data } = await OM.applyOnlineRefundTickets({
        orderNum: this.$route.params.orderNum,
        ticketNums: this.selectedTickets.map(t => t.ticketNum)
      });

      if (data.errCode === "00") {
        this.showDialog({
          title: this.$t(
            !!this.info.signupLottery
              ? "cancel_completed_title"
              : "refund_completed_title"
          ),
          content: this.$t(
            !!this.info.signupLottery
              ? "cancel_completed_desp"
              : "refund_completed_desp"
          ),
          buttons: [
            {
              text: this.$t("dialog_default_confirm"),
              action: () => {
                this.$router.push({
                  name: "OrderList"
                });
              }
            }
          ]
        });
      } else {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
                <img
                  src="/image/ic-warning@3x.png"
                  alt=""
                  style="width:80px"
                />
                <div class="mt-5">${this.$t("application_failed")}</div>
              </div>`
        });
      }
    },
    refundStatus(status) {
      switch (status) {
        case "已完成退票":
          return this.$t("refund_status_completed");
        case "拒絕退票":
          return this.$t("refund_status_rejected");
        case "已入場":
          return this.$t("refund_status_entry");
        default:
          return status;
      }
    },
    refundTicket(ticket) {
      if (
        ticket.onLineRefundStatusName !== "" &&
        ticket.onLineRefundStatusName !== "拒絕退票"
      )
        return;
      if (ticket.onLineRefundStatusName === "拒絕退票") {
        this.rejectDialog.content = ticket.rejectReason;
        this.rejectDialog.show = true;
        return;
      }
      if (!ticket.allowOnlineRefund) {
        this.dialog.show = true;
        return;
      }
    },
    async uploadPhoto(name, value) {
      let file = value;
      const allowedExtensions = ["jpg", "jpeg"];
      const extension = file.name
        .split(".")
        .pop()
        .toLowerCase();

      console.log("uploadPhoto", value);

      if (!allowedExtensions.includes(extension)) {
        // this.$emit("change", this.name, null);
        this.showDialog({
          alert: true,
          title: this.$t("activity_busy_title"),
          content: this.$t("activity_busy_content")
        });
        this.failDialog = {
          message: this.$t("refund_file_invalid"),
          show: true
        };
        setTimeout(() => {
          this.failDialog.show = false;
        }, 3000);
        return;
      }

      this.accountInfo.path = file;
    },
    async doSubmit() {
      this.confirmDialog.show = true;
    },
    nextStep() {
      this.selectedTickets = this.tickets.filter(t =>
        this.refund.includes(t.ticketNum)
      );

      const { transType, total, onlineRefundATMAccountPic } = this.info;

      if (
        transType === "ATM" &&
        total > 0 &&
        (!onlineRefundATMAccountPic || onlineRefundATMAccountPic === "")
      )
        this.status = "refund";
      else this.doSubmit();
    },
    async init() {
      const { data } = await OM.getOnlineRefundTickets(
        this.$route.params.orderNum
      );

      if (data.errCode === "00") {
        this.info = data?.data;
        this.tickets = data?.data.tickets;
        setTimeout(() => {
          this.isLoading = false;
        }, 1500);
      }
    }
  },
  async mounted() {
    await this.init();
  }
};
</script>

<style lang="scss" scoped>
.customCard {
  border-radius: 8px;
  overflow: hidden;
}

.bg-transparent-blue {
  background-color: #f1f9fe;
}

.bg-transparent-yellow {
  background-color: #fffcc2;
}

.order-header {
  font-size: 0.875rem;
  color: white;
  background-color: #116993;
  margin-top: -12px;
}

.blue-text {
  color: #12597a !important;
}

.row + .row {
  margin-top: 0;

  .col {
    padding-top: 12px;
    padding-bottom: 12px;
  }
}

.order-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
}

.row + .row.refund-row {
  border-bottom: 2px dotted #39a2cc;

  .col {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  &:nth-child(2n) {
    background-color: #f8f8f8;
  }
}

.row.refund-list {
  .col.refund {
    position: relative;
    display: flex;
    padding: 4px 0;
    border-bottom: 2px solid #eaeaea;

    .ribbon {
      position: absolute;
      width: 68px;
      top: 0;
      text-align: center;
      bottom: 0;
      margin: auto;
      height: 20px;
      line-height: 20px;
      left: 0;
      font-size: 12px;
      background-color: white;

      @media screen and (min-width: 960px) {
        width: 120px;
        font-size: 16px;
      }
    }

    &.is-entry,
    &.is-completed {
      .ribbon {
        color: #444;
      }
    }

    &.is-rejected {
      .ribbon {
        color: #c80025;
      }
    }
    &.is-proccessing {
      .ribbon {
        color: #28bd92;
      }
    }

    &:nth-child(2n),
    &:nth-child(2n) .ribbon {
      background-color: #f8f8f8;
    }

    ::v-deep .v-input--checkbox {
      margin: 0;
      padding: 0;
      width: 100%;

      &.v-input--is-disabled
        .v-input--selection-controls__input
        .v-icon::after {
        background-color: #c4c4c4;
        opacity: 1;
        width: 12px;
        height: 12px;
        border-radius: 3px;
        left: 0;
        right: 0;
        margin: auto;
        top: 0;
        bottom: 0;
      }

      .v-input--selection-controls__input {
        float: left;
        width: 68px;
        margin: 0;

        .v-input--selection-controls__ripple {
          left: 10px;
        }
        @media screen and (min-width: 960px) {
          width: 120px;
          .v-input--selection-controls__ripple {
            left: 35px;
          }
        }
      }

      .v-label {
        display: flex;
        width: 100%;
        flex: 1;

        > .d-flex {
          flex: 1;
          width: 100%;
        }

        .refund-item {
          display: flex;
          flex: 1;
          flex-direction: column;
          font-size: 12px;
          font-weight: bold;
          line-height: 140%;
          color: #444;
          padding: 8px;

          .label {
            color: #379cc4;
            font-weight: 500;
            line-height: 1;
            margin-bottom: 6px;
          }

          @media screen and (max-width: 959px) {
            flex: none;
            width: 50%;
          }

          @media screen and (min-width: 960px) {
            flex: none;
            width: 25%;
            font-size: 18px;

            .label {
              font-size: 16px;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
  }
}

.order-info {
  font-size: 16px;

  div {
    font-size: 12px;
  }

  @media screen and (min-width: 960px) {
    div {
      font-size: 18px;
    }

    h3 {
      font-size: 24px;
    }
  }
}

.spinner {
  width: 136px;
  height: 136px;
  position: relative;
}

.spinner-sector {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 8px solid transparent;
  mix-blend-mode: normal;
}

.spinner-sector-yellow {
  border-top-color: #fdda24;
}

.spinner-sector-blue {
  border-top-color: #379cc4;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spinner-sector-yellow {
  animation: rotate 1s ease-out infinite;
}

.spinner-sector-blue {
  animation: rotate 1.5s linear infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.25;
  }
}

.spinner-text {
  position: absolute;
  left: 44px;
  top: 57px;
  color: #ffffff;
  font-size: 16px;
  animation: pulse 1.5s ease-in-out infinite;
}

.atm-close-btn {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
  background-color: white;
}

::v-deep {
  .v-dialog {
    box-shadow: none !important;
  }
}
</style>
